<template>
  <div class="container">
    <a-config-provider :locale="zh_CN">
      <HomeHeader v-show="noHeader.indexOf(route.name) == -1"></HomeHeader>
      <router-view v-slot="{ Component }" class="Site-content">
        <transition name="fade" mode="out-in">
          <!-- <keep-alive :include='keepAlive'> -->
            <component :is="Component"/>
          <!-- </keep-alive> -->
        </transition >

      </router-view>

      <HomeFooter v-show="noFooter.indexOf(route.name) == -1"></HomeFooter>
    </a-config-provider>
  </div>
</template>

<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import HomeHeader from "@/components/public/header.vue"
import HomeFooter from "@/components/public/footer.vue"
import { useRoute } from 'vue-router'
export default {
  name: 'App',
  components: {
    HomeHeader,
    HomeFooter
  },
  setup () {
    const zh_CN = zhCN
    const route = useRoute()

    let noFooter = []
    let noHeader = ['login','payment']
    const keepAlive = []
    return {
      keepAlive,
      route,
      noHeader,
      noFooter,
      zh_CN
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #000000;
}
.container {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}
.Site-content {
  flex: 1;
}
</style>
